import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';

export function setupDoubleConference(): void {
  applicationModuleRegistry.register({
    entry: 'DOUBLE_CONFERENCE#9136',
    id: 'DOUBLE_CONFERENCE#9136',
    name: 'module.double-conference',
    route: ApplicationRoute.DOUBLE_CONFERENCE,
    routes: [
      {
        main: true,
        name: 'module.double-conference',
        route: ApplicationRoute.VALIDATE_HANDLING_ORDER,
      }
    ]
  });
}
